<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ 'VOID_DISH.VOID_DISH' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <!-- <hr> -->

  <div class="dialog-form">
    <div class="confirm-class">
      <div class="form-group" class="form-input-container">
        <div>
          {{ 'VOID_DISH.ARE_YOU_SURE_YOU_WANT_TO_VOID' | fallbackTranslate }}
          <label>{{ itemDetail.item_name }}</label>
          {{ 'VOID_DISH.FROM_THE_ORDER' | fallbackTranslate }}
        </div>
      </div>
    </div>

    <div
      class="form-input-container p-t-10"
      *ngIf="itemDetail.itemquantity !== 1"
    >
      <label>{{ 'VOID_DISH.ENTER_DISH_QTY_TO_VOID' | fallbackTranslate }}</label>
      <div class="item_quantity_container">
        <button
          (click)="addToCart(-1)"
          [disabled]="currentCount <= 1 ? true : null"
        >
          <i class="fa fa-minus"></i>
        </button>
        <input class="item_quantity fs-20 ta_center wd-100" type="number" [(ngModel)]="currentCount" (keydown)="validateInput($event)"/>
        <button
          (click)="addToCart(1)"
          [disabled]="currentCount == itemDetail.item_quantity ? true : null"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>

    <!-- Select Reason -->
    <div class="form-input-container">
      <label>{{ 'VOID_DISH.SELECT_REASON' | fallbackTranslate }}</label>
      <mat-radio-group
        aria-labelledby="example-radio-group1-label"
        class="example-radio-group1"
        [(ngModel)]="selectedOption"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="radioChanged($event)"
      >
        <div class="cards__item" *ngFor="let item of reasons">
          <span
            class="example-list-section1 c-pointer"
            (click)="setRadio(item.id)"
            [ngClass]="selectedOption == item.id ? 'radio-selected-div' : null"
          >
            <mat-radio-button class="example-radio-button" [value]="item.id">
              {{ item.name | fallbackTranslate }}
            </mat-radio-button>
          </span>
        </div>
        <div class="cards__item">
          <span
            class="example-list-section1 c-pointer"
            (click)="setRadio('custom')"
            [ngClass]="selectedOption == 'custom' ? 'radio-selected-div' : null"
          >
            <mat-radio-button class="example-radio-button1" value="custom">
              <input
                style="width: 100%"
                [ngClass]="
                  selectedOption == 'custom'
                    ? 'custom-reason-input-active'
                    : null
                "
                class="custom-reason-input"
                type="text"
                name="reason"
                id="reason"
                [(ngModel)]="reason_text"
                [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'VOID_DISH.ENTER_A_REASON' | fallbackTranslate }}"
              />
            </mat-radio-button>
          </span>
        </div>
      </mat-radio-group>
    </div>

    <div class="form-input-container p-t-10">
      <label>{{ 'VOID_DISH.NOTES' | fallbackTranslate }}</label>
      <div class="">
        <p class="void_notes">{{ 'VOID_DISH.VOID_NOTES' | fallbackTranslate }}</p>
        <ul class="void_notes_point">
          <li>{{ 'VOID_DISH.VOID_NOTES_POINT1' | fallbackTranslate }}</li>
          <li>{{ 'VOID_DISH.VOID_NOTES_POINT2' | fallbackTranslate }}</li>
          <li>{{ 'VOID_DISH.VOID_NOTES_POINT3' | fallbackTranslate }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer flex align_center">
    <div class="add-button" (click)="cancel_clicked()">
      {{ 'VOID_DISH.CANCEL' | fallbackTranslate }}
    </div>

    <button
      class="ml-25 cancel-button"
      (click)="voidDish()"
      [disabled]="btnDisabled || currentCount < 1"
    >
      {{ 'VOID_DISH.VOID_DISH' | fallbackTranslate }}
    </button>
  </div>
</div>
